module.exports = __webpack_public_path__ + "img/a5_1.5230cf76.jpg";